function f(name,val,conf){return{field_name:name,field_value:val,confidence:conf}}
function ago(h){return new Date(Date.now()-h*3600000).toISOString()}
function future(h){return new Date(Date.now()+h*3600000).toISOString()}

export const DEMO_DATA = [
  {
    id:'d1',reference_number:'VRE-TEST-20260327-8359',
    status:'ready_to_quote',broker_name:'Ryan Specialty',
    received_at:ago(2),sla_due_at:future(22),
    fields:[
      f('insured_name','Acme Metalworks LLC','high'),f('address','123 Industrial Blvd','high'),
      f('city','Columbus','high'),f('state','OH','high'),f('zip','43215','high'),
      f('construction_type','Masonry','high'),f('year_built','1998','high'),
      f('square_footage','45,000','high'),f('occupancy_class','CNC / Metalworking','high'),
      f('tiv','8500000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Central Station','high'),f('prior_losses_count','0','high'),
      f('prior_losses_value','0','high'),f('inception_date','May 1, 2026','high'),
      f('cat_score','Low','high'),f('roof_condition','Fair — original 2003','medium'),
      f('alarm_system','Central Station','high'),
    ],
    tiv_breakdown:{building:5100000,equipment:2550000,stock:595000,bi:255000},
    losses:[],
    evaluation:{
      outcome:'full_quote',score_total:74,score_tier:'standard',nle_value:547400,
      pricing_breakdown:{pml_value:9456250,mfl_value:9456250,vre_flags:[],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'}},
      indicated_premium:34238,gross_line:2125000,
      score_breakdown:{fire_protection:30,construction:16,risk_management:4,occupancy_hazard:14,loss_history:10},
    },
    narrative:`Acme Metalworks operates a CNC machining facility in Columbus, Ohio, representing $8.5M TIV. The facility scores 74/100 with exemplary fire protection but operational controls requiring confirmation through the virtual assessment.\n\nConstruction is masonry (1998), scoring 16/20. Fire protection is excellent — full sprinkler coverage with central station alarm achieves 30/30.\n\nLoss Expectancies: NLE $547K (6% of TIV). PML/MFL both equal $9.46M.\n\nPreliminary assessment complete. Primary gap is operational controls (4/20) — fire prevention program and hot work procedures require confirmation. Clean loss history is positive.`,
  },
  {
    id:'d2',reference_number:'VRE-TEST-20260327-4421',
    status:'in_progress',broker_name:'AmWINS Group',
    received_at:ago(5),sla_due_at:future(19),
    fields:[
      f('insured_name','Precision Parts Inc','high'),f('state','IN','high'),
      f('city','Indianapolis','high'),f('occupancy_class','Light Fabrication','high'),
      f('tiv','6200000','high'),f('construction_type','Joisted Masonry','high'),
      f('sprinkler_system',null,'missing'),f('year_built','2005','high'),
      f('square_footage','32,000','high'),f('prior_losses_count','1','high'),
      f('prior_losses_value','45000','high'),f('address',null,'missing'),
      f('zip',null,'missing'),f('cat_score',null,'missing'),f('roof_condition',null,'missing'),
    ],
    losses:[{date:'2023-06-15',cause:'Water damage — pipe burst',amount:45000,status:'Closed'}],
    evaluation:{
      outcome:'nbi',score_total:null,nle_value:null,
      pricing_breakdown:{pml_value:null,mfl_value:null,vre_flags:[]},
      indicated_premium_min:29000,indicated_premium_max:38000,gross_line:1550000,
      score_breakdown:null,
    },
  },
  {
    id:'d3',reference_number:'VRE-TEST-20260327-2209',
    status:'out_of_scope',broker_name:'Burns & Wilcox',
    received_at:ago(1),sla_due_at:future(23),
    decline_reason:'Geography: State TX is outside service area.\nOccupancy: Chemical processing cannot be assessed virtually.',
    fields:[
      f('insured_name','Gulf Coast Chemicals LLC','high'),f('state','TX','high'),
      f('occupancy_class','Chemical processing','high'),f('tiv','12000000','high'),
    ],
    losses:[],
    evaluation:{
      outcome:'appetite_decline',score_total:null,
      appetite_decline_reasons:[{rule:'state_excluded',value:'TX'},{rule:'occupancy_excluded',value:'Chemical processing'}],
      nle_value:null,pricing_breakdown:{pml_value:null,mfl_value:null,vre_flags:[]},
    },
  },
  {
    id:'d4',reference_number:'VRE-TEST-20260327-7703',
    status:'processing',broker_name:'Risk Placement Services',
    received_at:ago(0.25),sla_due_at:future(23.75),
    fields:[],losses:[],evaluation:null,
  },
  {
    id:'d5',reference_number:'VRE-TEST-20260327-5512',
    status:'out_of_scope',broker_name:'Worldwide Facilities',
    received_at:ago(8),sla_due_at:future(16),
    decline_reason:'Risk score 12/100 — below minimum threshold. Cannot produce a meaningful risk engineering report for this property.',
    fields:[
      f('insured_name','Midwest Plastics Corp','high'),f('state','OH','high'),
      f('occupancy_class','Plastic Injection Molding','high'),f('tiv','7800000','high'),
      f('construction_type','Frame','high'),f('sprinkler_system','No','high'),
      f('prior_losses_count','3','high'),f('prior_losses_value','242000','high'),
    ],
    losses:[
      {date:'2023-03-10',cause:'Fire — electrical fault',amount:125000,status:'Closed'},
      {date:'2022-08-22',cause:'Fire — hot work',amount:85000,status:'Closed'},
      {date:'2021-11-05',cause:'Water — sprinkler discharge',amount:32000,status:'Closed'},
    ],
    evaluation:{
      outcome:'score_decline',score_total:12,score_tier:'decline',nle_value:3900000,
      pricing_breakdown:{pml_value:10140000,mfl_value:10140000,
        vre_flags:[
          {code:'NO_SPRINKLER',severity:'critical',description:'No sprinkler system.'},
          {code:'FRAME_CONSTRUCTION',severity:'high',description:'Frame construction — MFL factor 1.30x.'}
        ],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'}},
      indicated_premium:null,gross_line:1950000,
      score_breakdown:{fire_protection:0,construction:4,risk_management:0,occupancy_hazard:8,loss_history:0},
    },
  },
  {
    id:'d6',reference_number:'VRE-TEST-20260327-6614',
    status:'assessment_sent',broker_name:'RT Specialty',
    received_at:ago(10),sla_due_at:future(14),
    sent_at:ago(6),
    fields:[
      f('insured_name','Great Lakes Medical Devices LLC','high'),f('address','882 Innovation Pkwy','high'),
      f('city','Ann Arbor','high'),f('state','MI','high'),f('zip','48103','high'),
      f('construction_type','Masonry','high'),f('year_built','2011','high'),
      f('square_footage','28,000','high'),f('occupancy_class','Medical Device Manufacturing','high'),
      f('tiv','11200000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Central Station','high'),f('prior_losses_count','0','high'),
      f('prior_losses_value','0','high'),f('inception_date','Jun 1, 2026','high'),
      f('cat_score','Low','high'),f('roof_condition','Good — replaced 2019','high'),
    ],
    losses:[],
    evaluation:{
      outcome:'full_quote',score_total:82,score_tier:'standard',nle_value:896000,
      pricing_breakdown:{pml_value:12544000,mfl_value:12544000,
        vre_flags:[{code:'CLEANROOM_INTERDEPENDENCY',severity:'medium',description:'Controlled environment — sole production facility assumed.'}],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'},nle_premium_ratio:0.05},
      indicated_premium:48200,gross_line:2800000,
      score_breakdown:{fire_protection:30,construction:16,risk_management:14,occupancy_hazard:20,loss_history:10},
    },
    narrative:`Great Lakes Medical Devices operates a controlled-environment manufacturing facility in Ann Arbor, Michigan, representing $11.2M TIV. Preliminary score 82/100 with excellent fire protection and clean loss record.\n\nMasonry construction (2011), roof replaced 2019. Full sprinkler with central station alarm achieves 30/30.\n\nLoss Expectancies: NLE $896K, PML/MFL $12.54M. Cleanroom interdependency flag raised — sole production facility assumed pending assessment confirmation.\n\nAssessment link sent to insured. Awaiting completion.`,
  },
  {
    id:'d7',reference_number:'VRE-TEST-20260327-7721',
    status:'awaiting_payment',broker_name:'AmWINS Group',
    received_at:ago(24),sla_due_at:future(8),
    sent_at:ago(18),
    fields:[
      f('insured_name','Hoosier Fabrication Inc','high'),f('address','441 Commerce Dr','high'),
      f('city','Fort Wayne','high'),f('state','IN','high'),f('zip','46802','high'),
      f('construction_type','Masonry','high'),f('year_built','2003','high'),
      f('square_footage','38,000','high'),f('occupancy_class','Light Fabrication','high'),
      f('tiv','7100000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Central Station','high'),f('prior_losses_count','1','high'),
      f('prior_losses_value','28000','high'),
      f('cat_score','Low','high'),f('roof_condition','Fair — original 2003','medium'),
    ],
    losses:[{date:'2022-04-18',cause:'Water — roof leak',amount:28000,status:'Closed'}],
    tiv_breakdown:{building:4260000,equipment:2130000,stock:568000,bi:142000},
    evaluation:{
      outcome:'full_quote',score_total:68,score_tier:'standard',nle_value:412000,
      pricing_breakdown:{pml_value:7952000,mfl_value:7952000,vre_flags:[],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'},nle_premium_ratio:0.07},
      indicated_premium:36800,gross_line:1775000,
      score_breakdown:{fire_protection:30,construction:16,risk_management:8,occupancy_hazard:14,loss_history:6},
    },
    narrative:`Hoosier Fabrication operates a light metal fabrication facility in Fort Wayne, Indiana. Scores 68/100 with good fire protection and one minor prior loss.\n\nMasonry construction (2003). Roof is original and rated fair — noted in report. Full sprinkler and central alarm.\n\nLoss Expectancies: NLE $412K, PML/MFL $7.95M. Water is the dominant damage vector (60%).\n\nReport generated. Awaiting payment to release.`,
  },
  {
    id:'d8',reference_number:'VRE-TEST-20260327-8830',
    status:'revision_requested',broker_name:'Burns & Wilcox',
    received_at:ago(36),sla_due_at:future(-2),
    revision_note:'Broker requests clarification on sprinkler design density figures in the Protection section.',
    sent_at:ago(30),
    fields:[
      f('insured_name','Buckeye Electronics Assembly','high'),f('address','770 Tech Park Blvd','high'),
      f('city','Dayton','high'),f('state','OH','high'),f('zip','45402','high'),
      f('construction_type','Fire Resistive','high'),f('year_built','2015','high'),
      f('square_footage','52,000','high'),f('occupancy_class','Electronics Assembly','high'),
      f('tiv','13500000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Central Station','high'),f('prior_losses_count','0','high'),
      f('prior_losses_value','0','high'),
      f('cat_score','Low','high'),f('roof_condition','Excellent — 2015','high'),
    ],
    losses:[],
    tiv_breakdown:{building:6750000,equipment:4725000,stock:1350000,bi:675000},
    evaluation:{
      outcome:'full_quote',score_total:88,score_tier:'highly_protected',nle_value:675000,
      pricing_breakdown:{pml_value:12960000,mfl_value:12960000,
        vre_flags:[
          {code:'SMOKE_CORROSIVITY',severity:'high',description:'Electronics assembly — confirm auto smoke venting.'},
          {code:'MFL_SEPARATION_UNVERIFIED',severity:'medium',description:'Large facility >50,000 sqft.'}
        ],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'},nle_premium_ratio:0.05},
      indicated_premium:52400,gross_line:3375000,
      score_breakdown:{fire_protection:30,construction:20,risk_management:16,occupancy_hazard:20,loss_history:10},
    },
    narrative:`Buckeye Electronics Assembly operates a modern electronics manufacturing facility in Dayton, Ohio. Scores 88/100 — excellent across all categories.\n\nFire resistive construction (2015), full sprinkler and central alarm. Clean loss record.\n\nSmoke corrosivity is the dominant loss characteristic (80%) — expected for electronics occupancies.\n\nLoss Expectancies: NLE $675K, PML/MFL $12.96M. Report released — revision requested by broker.`,
  },
  {
    id:'d9',reference_number:'VRE-TEST-20260327-9942',
    status:'report_released',broker_name:'Ryan Specialty',
    received_at:ago(72),sla_due_at:future(4),
    sent_at:ago(48),
    updated_at:ago(2),
    fields:[
      f('insured_name','Cardinal Tooling & Die LLC','high'),f('address','1255 Precision Way','high'),
      f('city','Cincinnati','high'),f('state','OH','high'),f('zip','45202','high'),
      f('construction_type','Masonry','high'),f('year_built','2007','high'),
      f('square_footage','41,000','high'),f('occupancy_class','CNC / Metalworking','high'),
      f('tiv','9800000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Central Station','high'),f('prior_losses_count','0','high'),
      f('prior_losses_value','0','high'),
      f('cat_score','Low','high'),f('roof_condition','Good — replaced 2018','high'),
    ],
    losses:[],
    tiv_breakdown:{building:5880000,equipment:2940000,stock:735000,bi:245000},
    evaluation:{
      outcome:'full_quote',score_total:78,score_tier:'standard',nle_value:618000,
      pricing_breakdown:{pml_value:10829000,mfl_value:10829000,vre_flags:[],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'},nle_premium_ratio:0.07},
      indicated_premium:42600,gross_line:2450000,
      score_breakdown:{fire_protection:30,construction:16,risk_management:12,occupancy_hazard:14,loss_history:10},
    },
    narrative:`Cardinal Tooling & Die operates a CNC precision machining facility in Cincinnati, Ohio. Scores 78/100 with strong fire protection and clean loss history.\n\nMasonry construction (2007), roof replaced 2018. Full sprinkler with central station alarm. Clean 3-year record.\n\nLoss Expectancies: NLE $618K (6% of TIV), PML/MFL $10.83M.\n\nRisk engineering report released.`,
  },
  {
    id:'d10',reference_number:'VRE-TEST-20260326-1103',
    status:'cancelled',broker_name:'Worldwide Facilities',
    received_at:ago(48),sla_due_at:future(-24),
    decline_reason:'Order cancelled — broker withdrew submission.',
    fields:[
      f('insured_name','Superior Packaging Solutions','high'),f('address','388 Industrial Ave','high'),
      f('city','Toledo','high'),f('state','OH','high'),f('zip','43605','high'),
      f('construction_type','Joisted Masonry','high'),f('year_built','1995','high'),
      f('square_footage','55,000','high'),f('occupancy_class','Packaging','high'),
      f('tiv','6800000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Local alarm','high'),f('prior_losses_count','2','high'),
      f('prior_losses_value','110000','high'),
      f('cat_score','Low','high'),f('roof_condition','Fair — original 1995','medium'),
    ],
    losses:[
      {date:'2023-07-22',cause:'Fire — equipment malfunction',amount:78000,status:'Closed'},
      {date:'2021-12-10',cause:'Water — roof penetration',amount:32000,status:'Closed'},
    ],
    evaluation:{
      outcome:'full_quote',score_total:58,score_tier:'standard',nle_value:544000,
      pricing_breakdown:{pml_value:7412000,mfl_value:7412000,
        vre_flags:[{code:'MFL_SEPARATION_UNVERIFIED',severity:'medium',description:'Large facility >50,000 sqft.'}],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'},nle_premium_ratio:0.07},
      indicated_premium:38400,gross_line:1700000,
      score_breakdown:{fire_protection:22,construction:10,risk_management:8,occupancy_hazard:14,loss_history:0},
    },
  },
  {
    id:'d11',reference_number:'VRE-TEST-20260326-2241',
    status:'report_released',broker_name:'RT Specialty',
    received_at:ago(120),sla_due_at:future(-96),
    sent_at:ago(96),
    updated_at:ago(26),
    fields:[
      f('insured_name','Lakeside Automation Systems','high'),f('address','901 Commerce Blvd','high'),
      f('city','Cleveland','high'),f('state','OH','high'),f('zip','44113','high'),
      f('construction_type','Masonry','high'),f('year_built','2009','high'),
      f('square_footage','33,000','high'),f('occupancy_class','Electronics Assembly','high'),
      f('tiv','8900000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Central Station','high'),f('prior_losses_count','0','high'),
      f('prior_losses_value','0','high'),
      f('cat_score','Low','high'),f('roof_condition','Good — replaced 2020','high'),
    ],
    losses:[],
    tiv_breakdown:{building:4450000,equipment:3560000,stock:668000,bi:222000},
    evaluation:{
      outcome:'full_quote',score_total:85,score_tier:'highly_protected',nle_value:534000,
      pricing_breakdown:{pml_value:9790000,mfl_value:9790000,vre_flags:[],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'},nle_premium_ratio:0.06},
      indicated_premium:44100,gross_line:2225000,
      score_breakdown:{fire_protection:30,construction:16,risk_management:18,occupancy_hazard:20,loss_history:10},
    },
    narrative:`Lakeside Automation Systems operates an electronics assembly facility in Cleveland, Ohio. Scores 85/100 — maximum marks across fire protection, occupancy hazard, and loss history.\n\nMasonry (2009), roof replaced 2020. Full sprinkler with central station. Clean record.\n\nLoss Expectancies: NLE $534K (6% of TIV), PML/MFL $9.79M. Risk engineering report released.`,
  },
  {
    id:'d12',reference_number:'VRE-TEST-20260327-1201',
    status:'ready_to_quote',broker_name:'RT Specialty',
    received_at:ago(6),sla_due_at:future(18),
    fields:[
      f('insured_name','Allied Precision Components LLC','high'),f('address','2201 Industrial Pkwy','high'),
      f('city','Cleveland','high'),f('state','OH','high'),f('zip','44105','high'),
      f('construction_type','Masonry','high'),f('year_built','2008','high'),
      f('square_footage','58,000','high'),f('occupancy_class','CNC / Metalworking','high'),
      f('tiv','14200000','high'),f('sprinkler_system','Yes – Adequate','high'),
      f('alarm_system','Central Station','high'),f('prior_losses_count','0','high'),
      f('prior_losses_value','0','high'),f('inception_date','Jul 1, 2026','high'),
      f('cat_score','Low','high'),f('roof_condition','Good — replaced 2017','high'),
    ],
    losses:[],
    tiv_breakdown:{building:8520000,equipment:4260000,stock:1065000,bi:355000},
    evaluation:{
      outcome:'full_quote',score_total:81,score_tier:'standard',nle_value:852000,
      pricing_breakdown:{pml_value:15706000,mfl_value:15706000,vre_flags:[],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'},nle_premium_ratio:0.05},
      indicated_premium:58400,gross_line:3550000,
      score_breakdown:{fire_protection:30,construction:16,risk_management:14,occupancy_hazard:14,loss_history:10},
    },
    narrative:`Allied Precision Components operates a large CNC machining facility in Cleveland, Ohio representing $14.2M TIV. Scores 81/100 with excellent fire protection and clean loss record.\n\nMasonry construction (2008), roof replaced 2017. Full sprinkler with central station. No prior losses.\n\nLoss Expectancies: NLE $852K (6% of TIV), PML/MFL $15.7M. Assessment complete — report under review.`,
  },
  {
    id:'d13',reference_number:'VRE-TEST-20260327-1302',
    status:'out_of_scope',broker_name:'Burns & Wilcox',
    received_at:ago(8),sla_due_at:future(16),
    decline_reason:'Frame construction with no sprinkler system — risk cannot be adequately assessed through virtual assessment alone.',
    fields:[
      f('insured_name','Delta Fabrication Works Inc','high'),f('address','445 Commerce St','high'),
      f('city','Akron','high'),f('state','OH','high'),f('zip','44301','high'),
      f('construction_type','Frame','high'),f('year_built','1988','high'),
      f('square_footage','29,000','high'),f('occupancy_class','Light Fabrication','high'),
      f('tiv','5800000','high'),f('sprinkler_system','No','high'),
      f('alarm_system','Local alarm','high'),f('prior_losses_count','1','high'),
      f('prior_losses_value','62000','high'),f('inception_date','May 15, 2026','high'),
      f('cat_score','Low','high'),f('roof_condition','Poor — original 1988','medium'),
    ],
    losses:[{date:'2022-09-14',cause:'Fire — electrical',amount:62000,status:'Closed'}],
    evaluation:{
      outcome:'score_decline',score_total:38,score_tier:'decline',nle_value:2900000,
      pricing_breakdown:{pml_value:7540000,mfl_value:7540000,
        vre_flags:[
          {code:'NO_SPRINKLER',severity:'critical',description:'No sprinkler system.'},
          {code:'FRAME_CONSTRUCTION',severity:'high',description:'Frame construction — MFL factor 1.30x.'}
        ],
        pml_breakdown:{assumption:'Single building — PML equals MFL.'},
        mfl_breakdown:{assumption:'Total failure.'}},
      indicated_premium:null,gross_line:1450000,
      score_breakdown:{fire_protection:0,construction:4,risk_management:6,occupancy_hazard:14,loss_history:6},
    },
  },
];